import { render, staticRenderFns } from "./RecursiveList.vue?vue&type=template&id=4a45b477"
import script from "./RecursiveList.vue?vue&type=script&lang=js"
export * from "./RecursiveList.vue?vue&type=script&lang=js"
import style0 from "./RecursiveList.vue?vue&type=style&index=0&id=4a45b477&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports